module.exports = __webpack_public_path__ + "static/media/PopupBlockedMenu.3c4357af.png";